class SessionExpiredError extends Error {
  constructor (message, response) {
    super(message)
    this.name = 'SessionExpiredError'
    this.code = 'sessionExpired'
    this.response = response
    // The platform's answer has no sessionEnd today; without one there is no date to show
    this.expirationDateReadable = response?.sessionEnd
      ? new Date(response.sessionEnd).toLocaleString(globalThis.navigator?.userLanguage || globalThis.navigator?.language)
      : null
  }
}

export default SessionExpiredError
